const MAGIC = new Uint8Array([0x4e, 0x47, 0x42, 0x31]); // NGB1
const VERSION = 1;
const SALT_BYTES = 16;
const IV_BYTES = 12;
const TAG_BYTES = 16;
const ITERATIONS = 100_000;
const AAD = new TextEncoder().encode('petrhythm/v1');
function bufferSource(bytes) {
    return bytes.slice().buffer;
}
function assertPassphrase(passphrase) {
    if (passphrase.trim().length < 8)
        throw new Error('복구 문구는 8자 이상이어야 해요.');
}
async function deriveKey(passphrase, salt) {
    const base = await crypto.subtle.importKey('raw', new TextEncoder().encode(passphrase), 'PBKDF2', false, ['deriveKey']);
    return crypto.subtle.deriveKey({ name: 'PBKDF2', salt: bufferSource(salt), iterations: ITERATIONS, hash: 'SHA-256' }, base, { name: 'AES-GCM', length: 256 }, false, ['encrypt', 'decrypt']);
}
/** PBKDF2-HMAC-SHA256 + AES-256-GCM, NGB1 binary contract from docs/15 §5. */
export async function encryptBackup(plaintext, passphrase) {
    assertPassphrase(passphrase);
    const salt = crypto.getRandomValues(new Uint8Array(SALT_BYTES));
    const iv = crypto.getRandomValues(new Uint8Array(IV_BYTES));
    const key = await deriveKey(passphrase, salt);
    const bytes = typeof plaintext === 'string' ? new TextEncoder().encode(plaintext) : plaintext;
    const ciphertext = new Uint8Array(await crypto.subtle.encrypt({ name: 'AES-GCM', iv: bufferSource(iv), additionalData: bufferSource(AAD), tagLength: TAG_BYTES * 8 }, key, bufferSource(bytes)));
    const result = new Uint8Array(MAGIC.length + 1 + salt.length + iv.length + ciphertext.length);
    result.set(MAGIC, 0);
    result[MAGIC.length] = VERSION;
    result.set(salt, MAGIC.length + 1);
    result.set(iv, MAGIC.length + 1 + salt.length);
    result.set(ciphertext, MAGIC.length + 1 + salt.length + iv.length);
    return result;
}
export async function decryptBackup(blob, passphrase) {
    assertPassphrase(passphrase);
    const minimum = MAGIC.length + 1 + SALT_BYTES + IV_BYTES + TAG_BYTES;
    if (blob.length < minimum || !MAGIC.every((byte, index) => blob[index] === byte) || blob[MAGIC.length] !== VERSION)
        throw new Error('지원하지 않는 백업 형식이에요.');
    const saltStart = MAGIC.length + 1;
    const ivStart = saltStart + SALT_BYTES;
    const cipherStart = ivStart + IV_BYTES;
    const salt = blob.slice(saltStart, ivStart);
    const iv = blob.slice(ivStart, cipherStart);
    const ciphertext = blob.slice(cipherStart);
    const key = await deriveKey(passphrase, salt);
    try {
        return new Uint8Array(await crypto.subtle.decrypt({ name: 'AES-GCM', iv: bufferSource(iv), additionalData: bufferSource(AAD), tagLength: TAG_BYTES * 8 }, key, bufferSource(ciphertext)));
    }
    catch {
        throw new Error('복구 문구가 맞지 않거나 백업이 손상됐어요.');
    }
}
export const BACKUP_CRYPTO = { iterations: ITERATIONS, magic: 'NGB1', version: VERSION, saltBytes: SALT_BYTES, ivBytes: IV_BYTES, tagBytes: TAG_BYTES };
